import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cfff549"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "overview-container" }

import MainSidebar from "@/components/MainSidebar.vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewView',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, "Welcome, " + _toDisplayString(_unref(store).state.current_user.name) + ".", 1)
    ])
  ]))
}
}

})